module.exports = __webpack_public_path__ + "static/media/shellslogo-black.b633f354.png";